import { EAN_PREFIX } from "@nano-portal/shared"
import { Controller } from "react-hook-form"
import { getFormError, getFormSuccess } from "../../../../../utils/form"
import { assertUnreachable } from "../../../../../utils/types"
import { Product } from "../../acquisitionForm/form/useAcquisitionFormSchema"
import { CheckboxedSection } from "../components/Checkbox"
import { EanInput } from "../components/EanInput"
import { FormItem, FormLabel } from "../components/Form"
import { useProductionPointFormContext } from "./productionPointForm.utils"

type Props = {
  selectedProduct: Product
}

export function ProductionPointEanField(props: Props) {
  const { selectedProduct } = props
  const form = useProductionPointFormContext()
  const ean = form.watch("ean")

  if (selectedProduct === "consumption") {
    throw new Error("Rendering production point fields but selected product is consumption")
  }

  if (selectedProduct === "productionAndConsumption") {
    return (
      <CheckboxedSection
        checkboxLabel="EAN výrobního místa je odlišný od odběrného."
        onCollapse={() => {
          form.resetField("ean")
          // eslint-disable-next-line unicorn/no-useless-undefined
          form.setValue("ean", undefined)
        }}
        open={!!ean}
        hiddenContent={
          <Controller
            control={form.control}
            name="ean"
            render={({ field }) => (
              <FormItem>
                <FormLabel>EAN</FormLabel>
                <EanInput
                  id="power-station-ean"
                  prefix={EAN_PREFIX}
                  {...field}
                  error={getFormError({ form, name: "ean" })}
                  success={getFormSuccess({ form, name: "ean" })}
                />
              </FormItem>
            )}
          />
        }
      />
    )
  }

  if (selectedProduct === "production") {
    return (
      <Controller
        control={form.control}
        name="ean"
        render={({ field }) => (
          <FormItem>
            <FormLabel>EAN</FormLabel>
            <EanInput
              id="ean"
              prefix={EAN_PREFIX}
              {...field}
              error={getFormError({ form, name: "ean" })}
              success={getFormSuccess({ form, name: "ean" })}
            />
          </FormItem>
        )}
      />
    )
  }

  return assertUnreachable(selectedProduct)
}
